export default __webpack_public_path__ + "static/media/pic5.23bd1ef2.jpg";